import React from 'react'
import RotateToLandscapeSvg from 'images/modules/Manage/i-rotate-to-ladscape.svg?raw'

export { default as RotateToLandscapeUrl} from 'images/modules/Manage/i-rotate-to-ladscape.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: RotateToLandscapeSvg}} />
)
